export default __webpack_public_path__ + "static/innotech-890e967ff2d5e45537d407390d9913d2.png";